module.exports = __webpack_public_path__ + "img/img12.a669bb1c.png";